import SelectablePill from '@ulta/core/components/SelectablePill/SelectablePill';

export default SelectablePill;